import { TIER_PLANS_LABELS } from "constants/tiers";
import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { BillingTier } from "types/generated";

type BillingTierBadgeProps = {
  tier: BillingTier;
};

const getTierBadgeVariant = (tier: BillingTier): BadgeVariants => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (tier) {
    case BillingTier.V4Starter:
    case BillingTier.V5Starter:
      return "green";
    case BillingTier.V4StarterPlus:
    case BillingTier.V5StarterPlus:
      return "blue";
    case BillingTier.V4Business:
    case BillingTier.V5Business:
      return "yellow";
    case BillingTier.V4Enterprise:
    case BillingTier.V5Enterprise:
      return "purple";
    case BillingTier.V5EnterprisePlus:
      return "fuchsia";
    default:
      return "gray";
  }
};

const BillingTierBadge = ({ tier }: BillingTierBadgeProps) => {
  return <Badge type="weak" variant={getTierBadgeVariant(tier)} text={TIER_PLANS_LABELS[tier]} />;
};

export default BillingTierBadge;
